module.exports = __webpack_public_path__ + "static/media/hero-boucher.1f79f2e3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/hero-boucher.webp
// module id = 201
// module chunks = 51